import { render } from "./TestimonialSlim.vue?vue&type=template&id=26cb4f4e"
import script from "./TestimonialSlim.vue?vue&type=script&lang=js"
export * from "./TestimonialSlim.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src900218826/src/production-ready-serverless-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__